import { render, staticRenderFns } from "./OrderDraftStatus.vue?vue&type=template&id=2aca534c&"
import script from "./OrderDraftStatus.vue?vue&type=script&lang=js&"
export * from "./OrderDraftStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports